import { Link } from "react-router-dom";
import SiteHeader, { MobileSearchBar } from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta(
    "页面不存在 - 无码高清资源平台",
    "你访问的页面不存在或已移动，返回首页继续浏览高清资源资讯。",
  );

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-lg w-full text-center">
          <p className="font-heading font-extrabold text-[72px] leading-none text-primary-200">404</p>
          <h1 className="mt-3 font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">
            这个页面走丢了
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-7">
            你访问的链接可能已经失效，或者地址输入有误。可以返回首页重新浏览，也可以直接搜索想看的内容。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2">
            <Link
              to="/"
              className="h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold flex items-center cursor-pointer transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/search"
              className="h-10 px-5 rounded-md border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 text-sm flex items-center gap-2 cursor-pointer transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line" aria-hidden="true"></i>
              搜索资源
            </Link>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {[
              { label: "影视资源", to: "/category/movie" },
              { label: "动漫资源", to: "/category/anime" },
              { label: "音乐资源", to: "/category/music" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="chip bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-700 cursor-pointer transition-colors"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <MobileSearchBar />
      <SiteFooter />
    </div>
  );
}